import update from 'immutability-helper';
import { Slot } from '../../../../interfaces/Slot';
import Store from '../../../../interfaces/Store';
import { SlotType } from '../../../../interfaces/SlotDefinition';

interface MoveArticleOnSingleSlotPayload {
  articleId: string;
  currentSlot: Slot;
  newSlot: Slot;
  newBlockedSlots: Slot[];
}

function clearSlots(slot: Slot, currentSlot: Slot): Slot {
  if (slot.type !== SlotType.LINE && slot.id === currentSlot.id) {
    return { ...slot, childId: undefined };
  }
  return slot;
}

function unblockSlots(slot: Slot, articleId: string): Slot {
  if (slot.type === SlotType.SINGLE && slot.blockedBy === articleId) {
    return { ...slot, blockedBy: undefined };
  }
  return slot;
}

function attachArticleOnNewSlot(
  slot: Slot,
  newSlot: Slot,
  articleId: string,
  newBlockedSlots: Slot[]
) {
  if (slot.id === newSlot.id) {
    return { ...slot, childId: articleId };
  }
  if (newBlockedSlots.some(blockedSlot => blockedSlot.id === slot.id)) {
    return { ...slot, blockedBy: articleId };
  }
  return slot;
}

export const moveArticleOnSingleSlotReducer = (
  store: Store,
  { articleId, currentSlot, newSlot, newBlockedSlots }: MoveArticleOnSingleSlotPayload
): Store => {
  const slots = store.configuration.slots
    .map(slot => clearSlots(slot, currentSlot))
    .map(slot => unblockSlots(slot, articleId))
    .map(slot => attachArticleOnNewSlot(slot, newSlot, articleId, newBlockedSlots));

  return update(store, {
    configuration: {
      slots: {
        $set: slots
      }
    }
  });
};
